import apiClient from 'helpers/api-client'
import { StateCreator } from 'zustand'
import { IIncomeOverview } from './interface'

export const createIncomeOverview: StateCreator<IIncomeOverview> = (
  set,
) => ({
  // state
  isLoadingIncome: false,
  incomeOverview: {
    total_income: 0,
    total_transaction: 0,
    year: 0,
    month: '',
  },

  // actions
  getIncomeOverview: async () => {
    try {
      set({ isLoadingIncome: true })
      const res = await apiClient.get('/wallet/hub/v1/income/summary')
      if (res?.data?.code === 'SUCCESS') {
        set({
          incomeOverview: res?.data?.data,
        })
      }
      set({ isLoadingIncome: false })
    } catch (error) {
      set({ isLoadingIncome: false })
      console.error(error)
    }
  },
})
